import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import classnames from 'classnames';

import { ClassProp } from 'helpers/types';

const styles = {
  root: {
    padding: '.750rem',
    borderRadius: '.375rem',
    boxShadow: '0 .125rem 1.25rem 0 rgba(0, 0, 0, 0.16)',
    border: 'solid .0625rem rgba(0, 0, 0, 0.03)',
    backgroundColor: '#fff',
  },
  title: {
    fontSize: '1rem',
    fontWeight: '500',

    '&.success': {
      color: '#683caf',
    },
    '&.warning': {
      color: '#f8a757',
    },
    '&.error': {
      color: '#f55947',
    },
  },
  description: {
    fontSize: '.750rem',
    lineHeight: '1.5',
    color: '#4a4a4a',
  },
  '@global .Toastify__toast-container--top-right': {
    width: '27.5rem',
    padding: '0',
    backgroundColor: 'transparent',
  },
  '@global .Toastify__toast--default': {
    padding: '0',
    margin: '0',
    backgroundColor: 'transparent',
    marginBottom: '1rem !important',
  },
};

export type ToastType = 'success' | 'warning' | 'error';

type Props = {
  title: string;
  description: string;
  classes: ClassProp<typeof styles>;
  type: ToastType;
};

const ToastContainer: FunctionComponent<Props> = ({
  title,
  description,
  classes,
  type,
}) => (
  <div className={classes.root}>
    <p className={classnames(classes.title, type)}>{title}</p>
    <span className={classes.description}>{description}</span>
  </div>
);

export default withStyles(styles)(ToastContainer);
